import moment from 'moment';

//check if date string is valid based on current locale
export const isValidDate = function (dateStr, dateFormat) {
  var date = moment(dateStr, dateFormat, true);
  return date.isValid();
};

export const getAge = (dob) => {
  const ageDifMs = Date.now() - dob.getTime();
  const ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};
